import axios from 'axios'

class ProcessTypeService {
  constructor (apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Martín Sánchez
  * @description get process types
  * @date 18-01-2021
  * @param {String} token
  * @returns {Object}
  * @memberof
  */
  async getProcessTypes (token) {
    const resp = await axios.get(`${this.apiUrl}/sign-processes`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then(function (response) {
        return response.data.data
      }).catch(function (error) {
        return { response: 'error,', data: error }
      })
    return resp
  }
}

export { ProcessTypeService as default }
